import { clsx } from 'clsx';
import { useRouteHook } from '@shared/hooks';
import { AmountUtils, ColorUtils, DateUtils, RoutePaths } from '@shared/utils';
import { type GetDepositPaymentsResponse } from '@shared/api/rest/payment';
import { Table, TableCellType, Text } from '@shared/widgets';

const COLUMNS = [
  'status',
  'direction',
  'reference no',
  'date',
  'to',
  'from',
  'description',
  'purpose',
  'fast payment',
  'exchange rate',
  'account number',
  'sender amount',
  'beneficiary Amount',
  'fee',
  'total amount',
];

interface TableProps {
  isLoading?: boolean;
  data: GetDepositPaymentsResponse[];
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangePage: (pageNumber: number) => void;
  onChangeCountItemPage: (pageNumber: number) => void;
}

export const PaymentTable = (props: TableProps) => {
  const { navigate } = useRouteHook();

  return (
    <Table
      isLoading={props.isLoading}
      isScrollable
      columns={COLUMNS}
      onClick={(rowIndex) => {
        const transactionItem = props.data[rowIndex];
        navigate(RoutePaths.accountTransaction.onNavigate(transactionItem.id));
      }}
      items={props.data.map((row) => {
        const color = ColorUtils.getDepositPaymentStatusStyles(row.status);
        return [
          { type: TableCellType.Custom, value: <div className={clsx('py-1 px-2 text-center font-normal', color.bg, color.text)}>{color.label}</div> },
          { type: TableCellType.Text, value: row.direction },
          { type: TableCellType.Text, value: row.referenceNumber },
          { type: TableCellType.Text, value: DateUtils.formatDate(row.date) },
          { type: TableCellType.Text, value: row.beneficiaryIban },
          { type: TableCellType.Text, value: row.senderIban },
          { type: TableCellType.Text, value: row.description },
          { type: TableCellType.Text, value: row.purpose || '-' },
          { type: TableCellType.Text, value: row.isFast ? 'Yes' : 'No' },
          {
            type: TableCellType.Text,
            value: (
              <Text>
                {AmountUtils.transformToAmountWithCurrency(1, row.currencyIn)} ={' '}
                {AmountUtils.transformToAmountWithCurrency(row.exchangeRate, row.currencyOut)}
              </Text>
            ),
          },
          { type: TableCellType.Text, value: row.accountNumber },
          { type: TableCellType.Text, value: `${AmountUtils.transformToAmountWithCurrency(row.senderAmount, row.currencyIn)}` },
          { type: TableCellType.Text, value: `${AmountUtils.transformToAmountWithCurrency(row.beneficiaryAmount, row.currencyOut)}` },
          { type: TableCellType.Text, value: `${AmountUtils.transformToAmountWithCurrency(row.fee, row.currency)}` },
          { type: TableCellType.Text, value: `${AmountUtils.transformToAmountWithCurrency(row.totalAmount, row.currency)}` },
        ];
      })}
      pagination={{
        currentPage: props.currentPage,
        totalItemCount: props.totalItemCount,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
    />
  );
};
